var map = {
	"./redroofs_10_1680.png": 2518,
	"./redroofs_10_420.png": 9382,
	"./redroofs_10_980.png": 4576,
	"./redroofs_1_1680.png": 3517,
	"./redroofs_1_420.png": 8636,
	"./redroofs_1_980.png": 334,
	"./redroofs_2_1680.png": 276,
	"./redroofs_2_420.png": 7832,
	"./redroofs_2_980.png": 7156,
	"./redroofs_3_1680.png": 3093,
	"./redroofs_3_420.png": 1206,
	"./redroofs_3_980.png": 9968,
	"./redroofs_4_1680.png": 4561,
	"./redroofs_4_420.png": 7633,
	"./redroofs_4_980.png": 1752,
	"./redroofs_5_1680.png": 3903,
	"./redroofs_5_420.png": 5653,
	"./redroofs_5_980.png": 5029,
	"./redroofs_6_1680.png": 2787,
	"./redroofs_6_420.png": 4663,
	"./redroofs_6_980.png": 8965,
	"./redroofs_7_1680.png": 9856,
	"./redroofs_7_420.png": 8453,
	"./redroofs_7_980.png": 7369,
	"./redroofs_8_1680.png": 9477,
	"./redroofs_8_420.png": 1104,
	"./redroofs_8_980.png": 5330,
	"./redroofs_9_1680.png": 8305,
	"./redroofs_9_420.png": 7598,
	"./redroofs_9_980.png": 8028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7482;